import BaseService from "./BaseService.js";

class AnalysisService extends BaseService {
  getAnalysis(view, options) {
    const config = {
      url: `/analysis/${view}`,
      params: {},
    };
    if (options) {
      Object.assign(config.params, { ...options });
    }
    return this.apiGet(config);
  }

  getAmpAnalysis(id) {
    return this.apiGet({
      url: `/tif/amp/${id}/analysis`,
    }) 
  }
}

export default new AnalysisService();
